export const apiAbort = {
    controllers: new Set(),

    new() {
        const controller = new AbortController()
        this.controllers.add(controller)
        return controller
    },

    cancel() {
        this.controllers.forEach(c => c.abort())
        this.controllers.clear()
    }
}
